import {
  GET_DISCOUNT_TYPE,
  GET_DISCOUNT_TYPE_FAILURE,
  GET_DISCOUNT_TYPE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getDiscountTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DISCOUNT_TYPE:
      return { ...state, loading: true };
    case GET_DISCOUNT_TYPE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_DISCOUNT_TYPE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getDiscountTypeReducer;
